/**
 * Data Access Interface
 */

import * as R from 'ramda'

import intf from './interface.js'
import schema from './schema.js'

const implementBy = impl => {
  const dataAccess = intf(impl)

  Object.keys(dataAccess).forEach(key => {
    if (!R.has(key, impl)) {
      throw new Error(`PurchaseOrderDataAccess implement needs ${key} function`)
    }
  })

  return dataAccess
}

export default {
  implementBy,
  interface: () => intf(),
  schema,
}
